import { _category } from "../constants/api";

export const getAllCategory = async() =>{
    try{
        const userData = JSON.parse(localStorage.getItem('user'));
         const token = userData?.token;

    if (!token) {
      throw new Error('Token not found');
    }
    const response = await fetch(`${_category}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'clientid': 'e0ce9cb8-430e-4148-b562-b8833cc9fa0b',
      },
    });

    const responseJSON = await response.json();
    return responseJSON;
    }catch(error){
        console.log('Error occurred in the get all category: ', error);
    }
}